import React, { createContext, useContext, useState, useCallback, useMemo } from "react";

// Normalize a data URL / raw base64 into { base64, mime }.
// iOS Safari returns full data URLs; the backend + Resend need pure base64.
function normalize(rawBase64) {
  if (!rawBase64) return { base64: "", mime: "image/jpeg" };
  if (rawBase64.startsWith("data:")) {
    const commaIdx = rawBase64.indexOf(",");
    const header = rawBase64.slice(5, commaIdx); // e.g. "image/jpeg;base64"
    const mime = header.split(";")[0] || "image/jpeg";
    return { base64: rawBase64.slice(commaIdx + 1), mime };
  }
  return { base64: rawBase64, mime: "image/jpeg" };
}

const FlowContext = createContext(null);

export function FlowProvider({ children }) {
  const [photo, setPhotoState] = useState({ dataUrl: null, base64: null, mime: null });

  const setPhoto = useCallback((dataUrl) => {
    const { base64, mime } = normalize(dataUrl);
    setPhotoState({ dataUrl, base64, mime });
  }, []);

  const reset = useCallback(() => {
    setPhotoState({ dataUrl: null, base64: null, mime: null });
  }, []);

  const value = useMemo(() => ({ photo, setPhoto, reset }), [photo, setPhoto, reset]);

  return <FlowContext.Provider value={value}>{children}</FlowContext.Provider>;
}

export function useFlow() {
  const ctx = useContext(FlowContext);
  if (!ctx) throw new Error("useFlow must be used within FlowProvider");
  return ctx;
}
